import type { MouseEvent, ReactNode } from 'react'
import Link from 'src/components/Link'

// Clique comum vira navegação no cliente (onNavigate); com tecla modificadora ou botão do
// meio, o navegador segue o href (nova aba etc.). TNDC-438.
export const navigationClickHandler =
  (page: number, onNavigate: (page: number) => void) =>
  (event: MouseEvent<HTMLAnchorElement>) => {
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return

    event.preventDefault()
    onNavigate(page)
  }

type PageLinkProps = {
  href: string
  page: number
  onNavigate?: (page: number) => void
  children: ReactNode
}

// Com onNavigate, <a> simples: o Link do Next busca o _next/data da página no hover (roda o
// getServerSideProps e chama a API), e esse resultado nunca seria usado, porque o clique é
// interceptado. O href fica no HTML para robôs e para quem está sem JS. TNDC-438.
export const PageLink = ({ href, page, onNavigate, children }: PageLinkProps) =>
  onNavigate ? (
    <a href={href} onClick={navigationClickHandler(page, onNavigate)}>
      {children}
    </a>
  ) : (
    <Link href={href}>{children}</Link>
  )
